import { styled } from '@mui/material';

export const sxStyles = {
  subtitle: {
    marginBottom: '1.5rem',
    padding: '0 0.625rem',
  },
  schoolSearch: {
    marginTop: '1.5rem',
  },
};

export const StyledStep1Wrap = styled('div')(() => ({
  textAlign: 'center',
  maxWidth: '432px',
  width: '100%',
  margin: '0 auto',

  '.MuiAutocomplete-clearIndicator': {
    display: 'none',
  },
}));
